'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import type { TabTypes } from '@/app/about/_types/offeringTypes';
export default function TabMenu(t0) {
  const $ = _c(9);
  const {
    tabItem,
    tabIndex,
    onTabClick
  } = t0;
  let t1;
  if ($[0] !== onTabClick || $[1] !== tabIndex || $[2] !== tabItem) {
    let t2;
    if ($[4] !== onTabClick || $[5] !== tabIndex) {
      t2 = (tab, index) => <button key={tab} type="button" className={clsx("tab_item", tabIndex === index ? "on" : "")} onClick={() => onTabClick(index)}>{tab}</button>;
      $[4] = onTabClick;
      $[5] = tabIndex;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = tabItem.map(t2);
    $[0] = onTabClick;
    $[1] = tabIndex;
    $[2] = tabItem;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <>{t1}</>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}